export default __webpack_public_path__ + "img/bc15a07a57a8c803cd5b0d2bf6723f4a.png";